import { render, staticRenderFns } from "./RipaLimitedEnglish.vue?vue&type=template&id=8927dd20"
import script from "./RipaLimitedEnglish.vue?vue&type=script&lang=js"
export * from "./RipaLimitedEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports